import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function organizationForRegister(iconStatus) {
  const query = `query organizationForRegister(
    $iconStatus: String
  ) {
  organizationForRegister(iconStatus: $iconStatus)  {  LimitedOrganizations{ name cageCode } 
  }
    }`;

  const variables = { iconStatus };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  if (
    response.organizationForRegister &&
    response.organizationForRegister.LimitedOrganizations
  ) {
    return response.organizationForRegister.LimitedOrganizations;
  }
  return {};
}

export async function getRFQbyID(userId, rfqId) {
  const query = `query rfqDetails(
    $userId: ID,
    $rfqId: String
  ) {
    rfqDetails(userId: $userId, rfqId: $rfqId)  {  rfq {cage email description rfqMaterial solNum  niin partNum partDesc quoteDueDate sampleDueDate orderDueDate qty releaseQty castingWt toolingAvailable sampleAvailable machiningReq toolingDesc prefCastProc secOpsReq reqCastSpec testingRqmts comment drawingNums nda ndaList attachmentsList status} participantsGrid{ quoteId cage convoId companyName rfqCreateDate quoteDate unitPrice quantity deliveryDate shipping totalCost status ndaAccept }   }
    }`;

  const variables = { userId, rfqId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  response.rfqDetails.rfq.niin = response.rfqDetails.rfq.niin.trim()

  return response;
}
// Local Deps

export async function putRFQ(rfqObj) {
  const query = `mutation PutRFQ($rfq: rfqInput) { PutRFQ (rfq: $rfq) { rfqId, status, msg  } }`;

  // Variables

  const {
    rfqId,
    userId,
    quoteDueDate,
    sampleDueDate,
    orderDueDate,
    description,
    niin,
    partDesc,
    qty,
    castingWt,
    toolingDesc,
    prefCastProc,
    reqCastSpec,
    testingRqmts,
    rfqMaterial,
    solNum,
    partNum,
    releaseQty,
    toolingAvailable,
    sampleAvailable,
    machiningReq,
    drawingNums,
    secOpsReq,
    comment,
    ndaId,
  } = rfqObj;

  const variables = {
    rfq: {
      rfqId,
      userId,
      quoteDueDate,
      sampleDueDate,
      orderDueDate,
      description,
      niin,
      partDesc,
      qty,
      castingWt,
      toolingDesc,
      prefCastProc,
      reqCastSpec,
      testingRqmts,
      rfqMaterial,
      solNum,
      partNum,
      releaseQty,
      toolingAvailable,
      sampleAvailable,
      machiningReq,
      drawingNums,
      secOpsReq,
      comment,
      ndaId,
    },
  };

  console.log(variables.rfq);

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function cancelRFQ(userId, rfqId) {
  const query = `mutation cancelRFQ($rfqId: Int, $userId: ID) { cancelRFQ (rfqId: $rfqId, userId: $userId) { status msg  } }`;

  // Variables

  const variables = {
    rfqId,
    userId,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function addNDA(userId, ndaDesc, attachmentNames) {
  const query = `mutation addNDAAttachment($userId: ID, $ndaDesc: String, $attachmentNames: [String]) { addNDAAttachment (userId: $userId, ndaDesc: $ndaDesc, attachmentNames: $attachmentNames) { status  } }`;

  // Variables

  const variables = {
    userId,
    ndaDesc,
    attachmentNames,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function addAttachment(userId, rfqId, attachmentNames) {
  const query = `mutation addRFQAttachment($userId: ID, $rfqId: String, $attachmentNames: [String]) { addRFQAttachment (userId: $userId, rfqId: $rfqId, attachmentNames: $attachmentNames) { status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    attachmentNames,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getNDAlist(userId, rfqId) {
  const query = `query rfqDetails(
    $userId: ID,
    $rfqId: String
  ) {
    rfqDetails(userId: $userId, rfqId: $rfqId)  {  rfq { nda ndaList }    }
    }`;

  const variables = { userId, rfqId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function getAttachmentList(userId, rfqId) {
  const query = `query rfqDetails(
    $userId: ID,
    $rfqId: String
  ) {
    rfqDetails(userId: $userId, rfqId: $rfqId)  {  rfq { attachmentsList } }
    }`;

  const variables = { userId, rfqId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function addParticipants(userId, rfqId, participants) {
  const query = `mutation addParticipants($userId: ID, $rfqId: Int, $participants: [String]) { addParticipants (userId: $userId, rfqId: $rfqId, participants: $participants) { status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    participants,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getUpdatedParticipantGrid(userId, rfqId) {
  const query = `query rfqDetails(
    $userId: ID,
    $rfqId: String
  ) {
    rfqDetails(userId: $userId, rfqId: $rfqId)  {   participantsGrid{
      quoteId cage convoId companyName rfqCreateDate quoteDate unitPrice quantity deliveryDate shipping totalCost status ndaAccept }   }
    }`;

  const variables = { userId, rfqId };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function handleRFQSubmit(userId, rfqId, participants) {
  const query = `mutation handleRFQSubmit($userId: ID, $rfqId: Int, $participants: [String]) { handleRFQSubmit (userId: $userId, rfqId: $rfqId, participants: $participants) { msg status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    participants,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function removeParticipants(userId, rfqId, participants) {
  const query = `mutation removeParticipants($userId: ID, $rfqId: Int, $participants: [String]) { removeParticipants (userId: $userId, rfqId: $rfqId, participants: $participants) { status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    participants,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function removeAttachment(userId, rfqId, attachmentId) {
  const query = `mutation removeAttachment($userId: ID, $rfqId: String, $attachmentId: String) { removeAttachment (userId: $userId, rfqId: $rfqId, attachmentId: $attachmentId) { status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    attachmentId,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/pages/contractRFQ/graphql.js